import React from "react";
import { ExternalLink } from "lucide-react";
import { clearImpersonationCookies, getImpersonationMeta } from "@/lib/authCookies";
import { getAppOrigin } from "@/lib/siteHosts";

const ImpersonationBanner = () => {
  const { clientName } = getImpersonationMeta();
  const label = clientName || "Client";

  const handleExit = () => {
    clearImpersonationCookies();
    try {
      window.close();
    } catch {
      /* ignore */
    }
    setTimeout(() => {
      const origin = getAppOrigin() || window.location.origin;
      window.location.href = `${origin.replace(/\/$/, "")}/partner/clients`;
    }, 100);
  };

  return (
    <div
      className="bg-[#00D2FF]/10 border-b border-[#00D2FF]/30 px-4 py-2.5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2"
      data-testid="impersonation-banner"
    >
      <p className="text-sm font-body text-[#00D2FF]">
        Managing <strong className="text-white">{label}</strong> · client console
      </p>
      <button
        type="button"
        onClick={handleExit}
        className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#00D2FF] hover:text-white transition-colors"
        data-testid="impersonation-exit"
      >
        <ExternalLink className="w-3.5 h-3.5" />
        Exit to Partner Console
      </button>
    </div>
  );
};

export default ImpersonationBanner;
